import React from 'react';
import {
  ChakraProvider,
  Text,
  theme,
} from '@chakra-ui/react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Dashboard from './pages/dashboard';
import SellerRequests from './pages/sellers-request';
import Payments from './pages/payments';
import Login from './pages/Login/login';
import Profile from './pages/profile';
import SellersList from './pages/sellers-list';
import AllTransactions from './pages/transactions';
import Admin from './pages/admin';
import ForgotPassword from './pages/forgot-password';
import EmailSent from './pages/forgot-password/email-sent';
import CreateNewPassword from './pages/create-new-password';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" Component={Login} />
        <Route path="/forgot-password" Component={ForgotPassword} />
        <Route path="/forgot-password/email-sent" Component={EmailSent} />
        <Route path="/create-new-password" Component={CreateNewPassword} />
        {/* <Route path="/dashboard" Component={Dashboard} /> */}
        <Route path="/profile" Component={Profile} />
        <Route path="/sellers-requests" Component={SellerRequests} />
        <Route path="/payments" Component={Payments} />
        <Route path="/transactions" Component={AllTransactions} />
        <Route path="/sellers-list" Component={SellersList} />
        <Route path="/users" Component={Admin} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
